<svelte:options
  customElement={{
    tag: "ofc-warranty-label-v1",
    shadow: "none",
    props: {
      duration: { type: "Number" },
      brand: { type: "String" },
      model: { type: "String" },
    },
  }}
/>

<script lang="ts">
  import type { Props } from "./WarrantyLabelV1.types.ts";
  import NestedLabel from "./NestedLabel.svelte";

  const { duration = 0, brand = "brand", model = "model" }: Props = $props();
  const sheetId = $props.id();
  let sheet = $state<HTMLOcSheetV1Element>();
  let sheetOpen = $state(false);

  function openSheet() {
    sheetOpen = true;
    sheet!.open = true;
    $host().dispatchEvent(
      new CustomEvent("ofc-warranty-label-sheet-open", {
        bubbles: true,
      }),
    );
  }
</script>

<button
  type="button"
  aria-label="{duration} {duration === 1 ? 'Jahr' : 'Jahre'} Garantie. Informationen anzeigen."
  onclick={openSheet}
>
  <NestedLabel {duration} />
</button>

<oc-sheet-v1 bind:this={sheet} id="ofc-warranty-label-v1-sheet-{sheetId}">
  {#if sheetOpen}
    {#await import('./LargeLabel.svelte') then {default: LargeLabel}}
      <LargeLabel {duration} {brand} {model} />
      <oc-link-v2>
          <a href="https:/*                                                                                                        */
            Informationen zur Haltbarkeitsgarantie auf europa.eu
          </a>
        </oc-link-v2>
    {/await}
  {/if}
</oc-sheet-v1>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  button {
    appearance: none;
    background: none;
    border: 1px solid tokens.$oc-base-color-black-100;
    border-radius: 1px;
    cursor: pointer;
    display: block;
    height: 22px;
    padding: 0;
    width: fit-content;
  }

  oc-link-v2 {
    display: block;
    margin-left: tokens.$oc-semantic-spacing-25;
  }
</style>
